<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction" />
    <div class="inner">
      <h1 id="vodProviderH1" v-translate>Poskytovatelé videa</h1>
    </div>
    <div class="inner_white">
      <div class="filter">
        <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
        </div>
        <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
      </div>

      <div class="table_overflow">
        <table class="vypis vypis_detail">
        <thead>
        <tr v-if="entities.length > 0">
          <th class="no_padding drag_drop" />
          <th class="no_padding checkbox" />
          <sorting-table-title
              v-for="title in tableTitles"
              :key="title.key"
              :column="title.column"
              :sort="getActiveSort(title.column)"
              @changeSorting="changeSorting"
          >{{ title.name }}</sorting-table-title>
          <th class="no_padding edit" />
        </tr>
        </thead>

        <vod-providers-row
            v-for="entity in entities"
            :entity="entity"
            :key="entity.id"
            @input="select"
            :selectedEntities="selectedEntities"
            :ref="'vod-providers-row-ref-'+entity.id"
        ></vod-providers-row>

        <tr v-if="entities.length === 0">
          <td colspan="3">{{ $gettext('Nebyli nalezeni žádní poskytovatelé videa.') }}</td>
        </tr>
      </table>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          @run-multiple-action="runMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          @select-all="toggleSelectAll"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import VodProvidersRow from "./VodProvidersRow.vue";
import listActions from "@/components/mixins/list-actions"

export default {
  name: "VodProviders",
  components: {
    VodProvidersRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'vodProviders',
      entitiesKey: 'vodProviders',
      formFields: {
        sort: {
          column: 'sName',
          direction: 'desc',
        },
      },
    }
  },
  created(VodProviderService) {
    this.entityService = VodProviderService;

    this.createdInit();
  },
  computed: {
    tableTitles() {
      return [
          {key: 1, name: this.$gettext('Název'), column: 'sName'},
          {key: 2, name: this.$gettext('Popis'), column: 'sDescription'},
          {key: 3, name: this.$gettext('Počet balíčků'), column: 'sPackageCount'},
          {key: 4, name: this.$gettext('Počet videí'), column: 'sVideosCount'},
      ];
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.tableTitles)
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodProviders/VodProvidersList.vue